import { defineMessages } from 'react-intl';

export default defineMessages({
  menu: {
    id: 'app.modules.shopDetails.MenuSection.menu',
    defaultMessage: 'Menú',
  },
  close: {
    id: 'app.modules.shopDetails.MenuSection.close',
    defaultMessage: 'Cerrar',
  },
  products: {
    id: 'app.modules.shopDetails.MenuSection.products',
    defaultMessage: '{total} productos',
  },
});
